import { Link, useMatches } from 'react-router';
import { AiFillHome } from 'react-icons/ai';

/**
 * 將 handle.breadcrumbParents 插在對應 match 之前；同一 to+title 只插一次。
 */
function buildBreadcrumbItems(matches) {
  const withTitle = matches.filter((match) => match.handle?.title);
  const items = [];
  const seenParentKeys = new Set();

  withTitle.forEach((match) => {
    const parents = match.handle?.breadcrumbParents;
    if (Array.isArray(parents)) {
      parents.forEach((parent) => {
        if (!parent?.title || !parent?.to) {
          return;
        }
        const key = `${parent.to}::${parent.title}`;
        if (seenParentKeys.has(key)) {
          return;
        }
        seenParentKeys.add(key);
        items.push({
          key: `parent:${key}`,
          title: parent.title,
          to: parent.to,
          isSynthetic: true,
        });
      });
    }

    items.push({
      key: match.id,
      title: match.handle.title,
      to: match.handle.breadcrumbTo || match.pathname,
      isSynthetic: false,
      match,
    });
  });

  return items;
}

const Breadcrumb = () => {
  const matches = useMatches();
  const breadcrumbItems = buildBreadcrumbItems(matches);

  return (
    <nav aria-label="麵包屑" className="mb-4 flex items-center text-sm text-gray-600">
      {breadcrumbItems.map((item, index) => {
        const isLast = index === breadcrumbItems.length - 1;
        const isFirst = index === 0;

        return (
          <div key={item.key} className="flex items-center">
            {isFirst && (
              <span className="mr-1">
                <AiFillHome size={16} />
              </span>
            )}

            {isLast ? (
              <span className="font-medium text-gray-800">{item.title}</span>
            ) : (
              <Link
                to={item.to}
                className="text-gray-500 transition-colors hover:text-gray-800"
              >
                {item.title}
              </Link>
            )}

            {!isLast && <span className="mx-2 text-gray-400">/</span>}
          </div>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
